import { Type } from '@angular/core';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { PrintMenu } from '../print-menu';
import { PrintHeaderLayoutType } from '../../enum/shared/print-header-layout-type.enum';
import { BandedRowMode } from '../../enum/shared/banded-row-mode.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnCannabinoidType } from '../../enum/shared/section-column-cannabinoid-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class TightPrintMenu extends PrintMenu {
  getPageBottomMargin(): string {
    return '0.5in';
  }

  getPageTopMargin(): string {
    return '0.5in';
  }

  getPageLeftMargin(): string {
    return '0.5in';
  }

  getPageRightMargin(): string {
    return '0.5in';
  }

  getThemeClass(): string {
    return 'tight-theme';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getPrintHeaderLayoutType(): PrintHeaderLayoutType {
    return this.menuOptions?.printHeaderLayout || PrintHeaderLayoutType.FirstPage;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getProductWrapperClass(odd: boolean) {
    return odd ? 'tight-print' : 'tight-print product-row-overlay';
  }

  bandedRowMode(): BandedRowMode {
    return BandedRowMode.Even;
  }

  bandedRowsDefaultEnabled(): boolean {
    return true;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Rubik.SemiBold_600,
      FONT.Rubik.Bold_700,
      FONT.Lato.Regular_400,
      FONT.Lato.Bold_700,
      FONT.Lato.Black_900
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/iah1inf.css';
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.ProductTitle, 0],
      [SectionColumnProductInfoType.Brand, 1],
      [SectionColumnProductInfoType.Strain, 2],
      [SectionColumnProductInfoType.StrainType, 3],
      [SectionColumnProductInfoType.Badge, 4],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(5),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(6),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(7, false),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(8),
      [SectionColumnProductInfoType.QuantityAndSize, 9],
      [SectionColumnProductInfoType.Quantity, 10],
      [SectionColumnProductInfoType.Size, 11],
      [SectionColumnProductInfoType.VariantType, 12],
      [SectionColumnProductInfoType.Stock, 13],
      [SectionColumnCannabinoidType.THCAndCBD, 14],
      [SectionColumnProductInfoType.GradingResults, 15],
      [SectionColumnProductInfoType.VariantPrice, 16],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 17]
    ]);
  }
}
